import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SettingsState } from '../../store/settings/settings.state';
import _ from 'lodash';
import { shortcutStringBuilderFromKeyboardEvent } from '../../helper/shortcutStringBuilder';
import { SettingsSelectors } from '../../store/settings/settings.selectors';
import { ShortcutTypeGlobal } from 'src/app/samwebDescription/samweb/shortcuts/shortcutTypeGlobal';
import { SamwinAcdExtensionState } from 'src/app/store/samwin/samwin-acd-extension/samwin-acd-extension.state';

@Injectable({
   providedIn: 'root',
})
export class HotkeyService {
   constructor(private store: Store) {}

   public handleKeyEvent(event: KeyboardEvent): boolean {
      if (_.isNil(this.store.selectSnapshot(SamwinAcdExtensionState.getAssignedAcdExtension))) {
         return false;
      }

      const shortcutString = shortcutStringBuilderFromKeyboardEvent(event);

      const globalHotkeySettings: ShortcutTypeGlobal[] = this.store.selectSnapshot(SettingsSelectors.getHotkeyTypeForShortcut)(shortcutString);
      if (_.isEmpty(globalHotkeySettings)) {
         return false;
      }
      globalHotkeySettings.forEach((hotkeysetting) => hotkeysetting.executeShortcut(this.store));
      return true;
   }
}
